import DetailPage from './DetailPage';

export default function LabDetailPage() {
  return (
    <DetailPage
      contentType="lab"
      backLink="/lab"
      relatedLabel="RELATED EXPERIMENTS"
      relatedAspectRatio="aspect-square"
      notFoundRedirect="/lab"
    />
  );
}
